module.exports = __webpack_public_path__ + "img/HQ-PA2W1UH-T.3d0c9a06.jpg";